import { toNumber, trim } from 'lodash'

const PATTERN = /^(\S+)\s+(\S+)\s+([\s\S]+)$/

export default function caaRdata(data)
{
	const matches = PATTERN.exec(trim(String(data ?? '')))

	if ( !matches )
	{
		return { flag: null, tag: null, value: null }
	}

	const [ , flag, tag, value ] = matches

	return {
		flag:  Number.isFinite(toNumber(flag)) ? toNumber(flag) : null,
		tag,
		value: value,
	}
}
